// extracted by mini-css-extract-plugin
export default {"wrapper":"EB-z","addressLine":"FB-z","fullName":"GB-z"};